
interface AddPlayerModalArgs {
    addPlayer: (playerId: string) => void;
    showBot: boolean;
}

interface AdminUser {
    id: string;
    name: string;
}

export const admin: AdminUser[] = [
    { id: 'ed0d8ac1-2d13-442d-8f9c-7294f4668e52', name: "Grant" },
    { id: '33c9897e-04ca-4d4a-8013-2fd92a39fd78', name: "Bill.KSU" },
    { id: 'db9baeb5-b802-47c0-83bb-9e159570f61f', name: "Dr. Ordinary" },
    { id: 'a60f1253-1544-4a52-9be2-38d0bb4a0ff8', name: "IvanMurzak1" },
    { id: 'a0e093bb-3935-40c8-b12a-bb7c0d960162', name: "IvanMurzak" },
    { id: '559fcb10-dec6-44c0-9cc0-582984df7a60', name: "Hamza_MS" },
    { id: '361a2fdb-0270-40b7-963c-a74af02d5f7b', name: "WilliamPiotrowski" },
    { id: '448902f4-872a-499d-a737-63d81ccd9a58', name: "TrippinLA" },
    { id: 'bc4aad59-3668-4469-890a-c6e20af64b4e', name: "Zzz" },
    // { id: 'd2c4fa61-ff0f-47af-a916-83940953c3f4', name: "Demo 1" },
    { id: '35f81fbb-fa0f-4322-b5a4-14c47eb3f956', name: "Demo 2" },
    { id: '2e7c998d-ff6b-4bbe-8afb-a0cb18e9d66b', name: "Demo 3" },
    { id: 'be9f270a-98a0-4379-85da-b864774f4d45', name: "FalloutDemo1" },
    { id: '695288b9-d401-4ea4-8246-8782fcfeec76', name: "FalloutDemo2" },
    // {id: 'ed0d8ac1', name: "Grant"},
    // {id: 'ed0d8ac1', name: "Grant"},
]

const AddPlayerModal: React.FC<AddPlayerModalArgs> = args => {

    return <div>
        <h2>Add Another Player</h2>
        <ul>
            {admin.map(u => {
                return <li><button
                    onClick={e => {
                        args.addPlayer(u.id);
                    }}
                >{u.name} : {u.id}</button></li>
            })}
        </ul>
        {args.showBot && <>
            <h2>Add Bot</h2>
            <p>The automated bot will take random actions.</p>
            <ul>
                <li><button
                    onClick={e => {
                        args.addPlayer("9a9db294-320f-4378-a71a-5f826e5cd241");
                    }}
                >Play Against Computer</button></li>
            </ul>
        </>}

    </div>
}

export default AddPlayerModal;